export default (isMobile: boolean, currentTab: number, itemsLength: number) => {
  const isFirstOrLastTab = currentTab === 1 || currentTab === itemsLength
  let maxItemsNumber = 7
  let minItemsNumber = 4

  if (isMobile) {
    maxItemsNumber = 5
    minItemsNumber = 3
  }

  // There are no ellipses
  if (isFirstOrLastTab) {
    return maxItemsNumber
  }

  // There is one ellipse
  if (currentTab < minItemsNumber || itemsLength - currentTab < minItemsNumber - 1) {
    return maxItemsNumber
  }

  // There are two ellipses
  return maxItemsNumber
}
